(function (app) {

    app.directive("blurOnEnter",
        function () {
            return function (scope, element) {
                element.bind("keydown keypress",
                    function (event) {
                        if (event.which === 13) {
                            event.preventDefault();
                            element.blur();
                        }
                    });
            };
        });

})(window.app); //jshint ignore:line